module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/192/assets/images/346813f28a14ee1177140ac68f217b1d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_maximise_dark.svg
// module id = d2jJ
// module chunks = 1